export enum EditableActionFields {
  TITLE = 'title',
  DUE_DATE = 'dueDate',
  DESCRIPTION = 'description',
  SEQUENCE = 'sequence',
  ACTION_OWNER = 'owner',
  ACTION_APPROVER = 'approver',
  ATTACHMENTS = 'attachments',
}
